import { useTranslation } from "react-i18next"
import { ScrollWrapper } from "@/components/scroll-wrapper"
import { MedicationItem } from "@/modules/patients/detail/medication/ch/medication-item"
import { chMedicationFragmentInline$data } from "@/modules/patients/detail/medication/ch/services/__generated__/chMedicationFragmentInline.graphql"
import { MedicationDetail } from "@/modules/patients/detail/medication/components/ch-medication-search"
import { useMedications } from "@/modules/patients/detail/medication/hooks/useMedications"
import { ChMedicationFragmentInlineList } from "@/modules/patients/detail/medication/types/medication-fragment-type"
import { Language } from "@/types/__generated__/union-types"

type MedicationViewerProps = {
  patientLanguage: Language
  handleSelectExistingMedication: (item: chMedicationFragmentInline$data, medication?: MedicationDetail) => void
}

export const MedicationViewer = ({ handleSelectExistingMedication, patientLanguage }: MedicationViewerProps) => {
  const { t } = useTranslation()
  const { activeMedications, inactiveMedications } = useMedications<ChMedicationFragmentInlineList>()

  return (
    <ScrollWrapper className="py-4">
      <div className="overflow-hidden">
        <div className="grid gap-8">
          {/* Active */}
          {activeMedications.length > 0 && (
            <div className="overflow-hidden" data-testid="active-medication-section">
              <p className="pb-4 font-medium">{t("patient.medication.active")}</p>
              {activeMedications.map((medication) => (
                <MedicationItem
                  key={medication.id}
                  medicationData={medication}
                  isActive
                  patientLanguage={patientLanguage}
                  handleSelectExistingMedication={handleSelectExistingMedication}
                />
              ))}
            </div>
          )}
          {/* Inactive */}
          {inactiveMedications.length > 0 && (
            <div className="overflow-hidden" data-testid="inactive-medication-section">
              <p className="pb-4 font-medium">{t("patient.medication.inactive")}</p>
              {inactiveMedications.map((medication) => (
                <MedicationItem
                  key={medication.id}
                  patientLanguage={patientLanguage}
                  medicationData={medication}
                  handleSelectExistingMedication={handleSelectExistingMedication}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </ScrollWrapper>
  )
}
